var path = 'js/components/info-window/info-window.template.html';
var html = "<div class=modal-header> <button type=button class=close data-dismiss=modal aria-label=Close ng-click=$dismiss()><span aria-hidden=true>×</span></button> <h4 class=modal-title>{{$ctrl.title}}</h4> </div> <div class=modal-body> <span ng-bind-html=$ctrl.body></span> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/info-window/info-window.template.html
// module id = 161
// module chunks = 0